import { MOTIF_FULL_COLOR_LABELLED, MOTIF_ONE_COLOR_FOREST } from '@/assets/motif';

// The supplied SVG has viewBox only; give the root element a fluid size so its
// intrinsic (viewBox) width can never widen a grid track on small screens.
const fluid = (svg: string) =>
  svg.replace('<svg ', '<svg width="100%" style="display:block;width:100%;height:auto" ');

interface MotifProps {
  /** 'full' (forest grounds, labeled, in color) or 'forest' (one color, for cream grounds). */
  variant: 'full' | 'forest';
  className?: string;
}

/**
 * The sealed-cloud estate illustration. Decorative: the surrounding copy
 * carries the meaning, so it is hidden from assistive technology.
 */
const Motif = ({ variant, className }: MotifProps) => (
  <div
    className={className}
    aria-hidden="true"
    dangerouslySetInnerHTML={{
      __html: fluid(variant === 'full' ? MOTIF_FULL_COLOR_LABELLED : MOTIF_ONE_COLOR_FOREST),
    }}
  />
);

export default Motif;
